export const CATEGORY_FETCH_REQUESTED = 'CATEGORY_FETCH_REQUESTED';
export const CATEGORY_FETCH_SUCCEEDED = 'CATEGORY_FETCH_SUCCEEDED';
export const CATEGORY_FETCH_FAILED = 'CATEGORY_FETCH_FAILED';

export const CATEGORY_NAVIGATE = 'CATEGORY_NAVIGATE';
